window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

let axios = require('axios');
window.axios = axios.create({
    baseURL: window.Voalle.api,
    timeout: 120 * 1000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + window.Voalle.token,
        'X-Requested-With': 'XMLHttpRequest',
        'X-AGENCIAS3-Dev': 'V1.0',
        'X-CSRF-TOKEN': window.Voalle.csrf
    },
    withCredentials: false
});

if (window.Voalle.token) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.Voalle.token;
}

const Utilidades = require('./classes/utilidades').default;
window.Voalle.Utilidades = Utilidades;

window.Swal = require('sweetalert2');
